

































import Vue from 'vue'
import { FETCH_TOOLS, RUN_TOOLS } from '@/store/action-types'
import { GetToolsResponse, ResponseBase } from '@/types/service-response'
import { ToolsPayload } from '@/types/payload'
import { Tools } from '@/model/Tools'
import { ProjectDetail } from '@/model/project/ProjectDetail'
import WarningDialog from '@/components/WarningDialog.vue'

interface ComponentData {
  showWarningDialog: boolean
  warningMessage: string
  toolsMenu1: boolean
  toolsMenu2: boolean
  selectedTool: Tools | null
  clickedTool: Tools | null
  toolsItems: Tools[]
}

export default Vue.extend({
  name: 'ToolsTreeMenu',

  props: {
    showMenu: Boolean,
    projectId: Number,
    projectDetail: Object as () => ProjectDetail || null
  },

  data (): ComponentData {
    return {
      showWarningDialog: false,
      warningMessage: '',
      toolsMenu1: false,
      toolsMenu2: false,
      selectedTool: null,
      clickedTool: null,
      toolsItems: [],
    }
  },

  components: {
    WarningDialog
  },

  computed: {},

  methods: {
    onToolsClick (item: Tools): void {
      if(item.children.length > 0) {
        this.toolsMenu2 = true
        this.selectedTool = item
      } else {
        this.toolsMenu1 = false
        this.toolsMenu2 = false
        this.selectedTool = null
        this.clickedTool = item
        this.warningMessage = item.question
        this.showWarningDialog = true
      }
    },

    onWarningDialogClose (): void {
      this.selectedTool = null
      this.clickedTool = null
      this.showWarningDialog = false
    },

    onWarningDialogSave (item: Tools): void {
      this.selectedTool = null
      this.clickedTool = null
      this.showWarningDialog = false
        this.runTools(item)
    },

    async runTools (item: Tools): Promise<void> {

      const payload: ToolsPayload = {
        Code: item.code!,
        Parameters: item.parameters
      }

      for (const param of payload.Parameters) {
        switch (param.Code) {
          case 'pj':
            param.Value = this.projectId
            break;

          case 'pjd':
            param.Value = this.projectDetail ? this.projectDetail.ID : null
            break;

          case 'prd':
            param.Value = this.projectDetail ? this.projectDetail.Produkt : null
            break;
        }
      }

      try {
        this.$emit('loading', true)
        const response: ResponseBase = await this.$store.dispatch(RUN_TOOLS, payload)
        this.$emit('loading', false)
        if (!response.IsError) {
          this.$emit('toolsSuccessSnackbar')
        } else {
          this.$emit('toolsErrorSnackbar')
        }
      } catch {
        this.$emit('loading', false)
        this.$emit('toolsErrorSnackbar')
      }
    },

    async fetchData (): Promise<void> {
      const response: GetToolsResponse = await this.$store.dispatch(FETCH_TOOLS, 'frmProjekt')
      this.toolsItems = Tools.createFromResponse(response.Tools)
    },
  },

  mounted () {
    this.fetchData()
  }

})
